import {Component, OnInit} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../../rest-api.service';
import {MessageService} from '../../message.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-create-docu',
  templateUrl: './create-docu.component.html',
  styleUrls: ['./create-docu.component.css']
})
export class CreateDocuComponent implements OnInit {

  radioButton: any;
  displayed = false;
  added = new Array();
  ticketTypes: any;
  name: string;
  brief: string;
  rDate = '';
  dDate = '';
  clientId: any;
  private notifier: NotifierService;
  respObject: any;

  radioChecked: any;
  cat = [];
  attachment = [];
  uploadButtonName = 'Upload File';
  fileUploadUrl: string;
  add = false;
  public clientName: string;
  private typeSeq: number | string | any;
  groups = [];
  supportGroupSelected = [];
  users = [];
  userSelected = [];
  download: boolean;
  upload: boolean;
  deleted: boolean;

  actions = [];

  private sGroups = [];
  private sUsers = [];
  originalName: string;
  private baseCategories = [];

  constructor(private _rest: RestApiService, notifier: NotifierService, private messageService: MessageService) {
    this.notifier = notifier;
  }

  get selectedOptions() {
    return this.actions
      .filter(opt => opt.checked)
      .map(opt => opt);

  }

  ngOnInit() {
    this.download = false;
    this.upload = false;
    this.deleted = false;
    this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
    this._rest.getDocuActions().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.actions = this.respObject.details;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
        this.clientName = this.respObject.details[0].client;
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          // console.log('ticket type=', JSON.stringify(this.respObject));
          if (this.respObject.success) {
            // this.radioChecked = this.respObject.details[0].id;
            for (let i = 0; i < this.respObject.details.length; i++) {
              if (this.respObject.details[i].seq === this.messageService.DOCU_TYPE) {
                this.radioChecked = this.respObject.details[i].id;
                break;
              }
            }
            // console.log('this.displayed:' + this.displayed);
            this.typeSeq = this.respObject.details[0].seq;
            this.radioButton = this.respObject.details;
            this.getTicketLoadingData();
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });

  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  // onButtonChange(selectedButton) {
  //   // console.log('+++++++++++++++++', selectedButton, selectedButton.value.id)
  //   this.radioChecked = selectedButton.value.id;
  //
  //   this.getTicketLoadingData();
  //   if (this.attachment.length > 0) {
  //     this.attachment = [];
  //   }
  //   this.typeSeq = selectedButton.value.seq;
  // }

  getTicketLoadingData() {
    this._rest.getDocuTicketDetails(this.messageService.getUserId(), this.radioChecked).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
        this.ticketTypes = this.respObject.details[0].attribute;
        this.cat = [];
        this.clientId = this.respObject.details[0].clientId;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  onCategoryChange(ticket, option) {
    console.log(JSON.stringify(ticket), typeof option, ticket.id);
    // if(this.ticketTypes)

    const opt = JSON.parse(option);
    if (opt.type !== 'header') {
      if (this.attachment.length > 0) {
        this.attachment = [];
      }
      const value = opt.id;
      let matched = false;
      const index = this.ticketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id + 1);
      // console.log('index:' + index);
      const index1 = this.ticketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id);
      const pid = this.ticketTypes[index1].options[0].id;
      // console.log(this.ticketTypes[index1].options[0]);
      if (this.cat.length === 0) {
        this.cat.push({pid: pid, cid: value});
      } else {
        for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].pid === pid) {
            matched = true;
            this.cat[i].cid = value;
            break;
          }
        }
        if (!matched) {
          this.cat.push({pid: pid, cid: value});
        } else {
          for (let i = index; i < this.cat.length; i++) {
            // console.log('matched');
            // console.log(this.cat[i]);
            if (index > -1) {
              this.cat[i].cid = 0;
            }
          }
        }
      }
      // clear sub categories
      console.log('index:' + index);
      if (index > -1) {
        // console.log('index:' + index);
        for (let i = index + 1; i < this.ticketTypes.length; i++) {
          const options = this.ticketTypes[i].options;
          // console.log(JSON.stringify(options));
          for (let j = 0; j < options.length; j++) {
            if (options[j].type) {
              // options=[];
              this.ticketTypes[i].options = [options[j]];
              break;
            }
          }
        }
        this._rest.getSupportGroupByCategory(this.clientId, value).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.respObject.details.unshift({id: 0, name: 'All Groups'});
            this.groups = this.respObject.details;
            // this.supportGroupSelected = 0;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
      }
      // console.log(value);
      if (ticket.id === 1) {
        this._rest.getSupportGroupByCategory(this.clientId, value).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.respObject.details.unshift({id: 0, name: 'All Groups'});
            this.groups = this.respObject.details;
            // this.supportGroupSelected = 0;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });

      }
      this._rest.getAttributesParentWise(this.clientId, value).subscribe((res) => {
        this.respObject = res;
        console.log(index);
        let data;
        if (index > -1) {
          data = this.ticketTypes[index].options[0];
        }
        if (this.respObject.success) {
          this.respObject.details.unshift(data);
          this.ticketTypes[index].options = this.respObject.details;
        } else {
          if (index > -1) {
            this.ticketTypes[index].options = [data];
          }
          // this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    }
  }

  resetField() {
    this.name = '';
    this.brief = '';
    this.rDate = '';
    this.dDate = '';
    this.attachment = [];
    this.cat = [];
    this.originalName = '';
    // this.ticketTypes = this.baseCategories;
    this.ticketTypes = this.messageService.copyArray(this.baseCategories);
    // for (let i = 1; i < this.ticketTypes.length; i++) {
    //   const options = this.ticketTypes[i].options;
    //   console.log(JSON.stringify(options));
    //
    //   for (let j = 0; j < options.length; j++) {
    //     if (options[j].type) {
    //       // options=[];
    //       this.ticketTypes[i].options = [options[j]];
    //       break;
    //     }
    //   }
    // }
  }

  // onGroupChange() {
  //   this.sGroups = [];
  //   if (this.supportGroupSelected.indexOf(0) > -1) {
  //     this.supportGroupSelected = [];
  //     for (let i = 0; i < this.groups.length; i++) {
  //       if (this.groups[i].id !== 0) {
  //         this.sGroups.push(this.groups[i].id);
  //         this.groups[i].isDisabled = true;
  //       }
  //       this.supportGroupSelected.push(this.groups[i].id);
  //     }
  //   } else {
  //     for (let i = 0; i < this.groups.length; i++) {
  //       if (this.groups[i].id !== 0) {
  //         this.groups[i].isDisabled = false;
  //       }
  //     }
  //     for (let i = 0; i < this.supportGroupSelected.length; i++) {
  //       this.sGroups.push(this.supportGroupSelected[i]);
  //     }
  //   }
  //   console.log(JSON.stringify(this.supportGroupSelected));
  //   if (this.sGroups.length > 0) {
  //     this._rest.getUsersByMultiGroup(this.clientId, this.sGroups).subscribe((res1) => {
  //       this.respObject = res1;
  //       if (this.respObject.success) {
  //         this.respObject.details.unshift({id: 0, name: 'All User'});
  //         this.users = this.respObject.details;
  //         // console.log(JSON.stringify(this.users));
  //         // this.userSelected = 0;
  //       } else {
  //         this.notifier.notify('error', this.respObject.errorMessage);
  //       }
  //     }, (err) => {
  //       this.notifier.notify('error', this.messageService.SERVER_ERROR);
  //     });
  //   } else {
  //     this.users = [];
  //   }
  // }

  uploadDocu() {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      // if (this.selectedOptions.length > 0) {
      let cats = '';
      let isError = false;

      console.log(JSON.stringify(this.cat));
      if (this.cat.length === this.ticketTypes.length) {
        for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].cid !== 0) {
            cats += this.cat[i].pid + '#' + this.cat[i].cid;
            if (i !== this.cat.length - 1) {
              cats += ',';
            }
          } else {
            isError = true;
            break;
          }
        }
      } else {
        isError = true;
      }
      console.log(cats);

      if (isError) {
        this.notifier.notify('error', this.messageService.CATEGORY_ERROR);
      } else {
        const allActions = [1, 2, 3];
        // for (let j = 0; j < this.selectedOptions.length; j++) {
        //   if (this.selectedOptions[j] !== 4) {
        //     allActions.push(this.selectedOptions[j]);
        //   }
        // }
        this.sUsers = [this.messageService.getUserId()];
        const data = {
          'clientId': this.clientId,
          'typeId': this.radioChecked,
          'title': this.name,
          'longDesc': this.brief,
          'attachmentPath': this.attachment,
          // 'attachmentPath': ['abc.txt'],
          'requestedDate': this.rDate,
          'dueDate': this.dDate,
          'createdBy': this.messageService.getUserId(),
          'categoryDtlsLt': cats,
          // 'groupId': this.sGroups,
          'actions': allActions,
          'users': this.sUsers
        };
        console.log(JSON.stringify(data));
        if (!this.messageService.isBlankField(data) && this.sUsers.length > 0) {
          this._rest.uploadDocument(data).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
              this.notifier.notify('success', this.respObject.details);
            } else {
              this.notifier.notify('error', this.respObject.errorMessage);
            }
          }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
        } else {
          this.notifier.notify('error', this.messageService.BLANK_ERROR_MESSAGE);
        }
      }
      // } else {
      //   this.notifier.notify('error', this.messageService.BLANK_ACTION);
      // }
    }
  }

  onFileComplete(data: any) {
    this.attachment = [];
    if (data.success) {
      this.originalName = data.fileName + ' is chosen for uploading.';
      this.attachment.push({originalName: data.fileName, fileName: data.changedName});
    }
  }


  // checkAll(checked: boolean, index: any) {
  //   if (this.actions[index].id === 4) {
  //     if (checked) {
  //       for (let i = 0; i < this.actions.length; i++) {
  //         this.actions[i].checked = true;
  //       }
  //     } else {
  //       for (let i = 0; i < this.actions.length; i++) {
  //         this.actions[i].checked = false;
  //       }
  //     }
  //   } else {
  //     if (!checked) {
  //       for (let i = 0; i < this.actions.length; i++) {
  //         if (this.actions[i].id === 4) {
  //           this.actions[i].checked = false;
  //           break;
  //         }
  //       }
  //     }
  //   }
  //   // console.log(checked, JSON.stringify(this.actions[i]), i);
  // }
  //
  // addDocu() {
  //   if (this.selectedOptions.length > 0) {
  //
  //     if (this.sUsers.length > 0) {
  //       for (let i = 0; i < this.sUsers.length; i++) {
  //         for (let j = 0; j < this.selectedOptions.length; j++) {
  //           const a = {};
  //           if (this.selectedOptions[j].id !== 4) {
  //
  //             a['actionId'] = this.selectedOptions[j].id;
  //             a['actionName'] = this.selectedOptions[j].action;
  //             a['userId'] = this.sUsers[i].userId;
  //             a['uname'] = this.sUsers[i].uname;
  //             a['groupId'] = this.sUsers[i].groupId;
  //             // console.log('after:' + JSON.stringify(this.sUsers[i]));
  //             this.added.push(a);
  //             // console.log(JSON.stringify(this.added));
  //           }
  //         }
  //
  //       }
  //     }
  //     console.log(JSON.stringify(this.added));
  //   } else {
  //     this.notifier.notify('error', this.messageService.BLANK_ACTION);
  //   }
  // }
  //
  // onUserChange() {
  //   this.sUsers = [];
  //   if (this.userSelected.indexOf(0) > -1) {
  //     this.userSelected = [];
  //     for (let i = 0; i < this.users.length; i++) {
  //       if (this.users[i].id !== 0) {
  //         this.sUsers.push({userId: this.users[i].id, groupId: this.users[i].groupId, uname: this.users[i].name});
  //         this.users[i].isDisabled = true;
  //       }
  //       this.userSelected.push(this.users[i].id);
  //     }
  //   } else {
  //     for (let i = 0; i < this.users.length; i++) {
  //       if (this.users[i].id !== 0) {
  //         this.users[i].isDisabled = false;
  //       }
  //       for (let j = 0; j < this.userSelected.length; j++) {
  //         if (this.userSelected[j] === this.users[i].id) {
  //           this.sUsers.push({userId: this.users[i].id, groupId: this.users[i].groupId, uname: this.users[i].name});
  //         }
  //       }
  //     }
  //     // for (let i = 0; i < this.userSelected.length; i++) {
  //     //   this.sUsers.push(this.userSelected[i]);
  //     // }
  //   }
  // }
}
